var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.84617 18C9.7094 17.9996 9.57418 17.971 9.44892 17.9162C9.32366 17.8613 9.21102 17.7813 9.11802 17.6812L4.27037 12.53C4.08916 12.3371 3.99209 12.0802 4.00051 11.8158C4.00892 11.5514 4.12214 11.3012 4.31526 11.1201C4.50838 10.9391 4.76557 10.8422 5.03026 10.8506C5.29495 10.859 5.54545 10.9721 5.72666 11.165L9.83619 15.539L18.2248 6.37249C18.3099 6.2666 18.4158 6.17922 18.536 6.1157C18.6562 6.05218 18.7881 6.01387 18.9236 6.00312C19.0592 5.99238 19.1955 6.00942 19.3242 6.05321C19.4528 6.097 19.5712 6.16661 19.672 6.25776C19.7728 6.34891 19.8539 6.45968 19.9102 6.58327C19.9666 6.70685 19.9971 6.84065 19.9998 6.97643C20.0025 7.11221 19.9774 7.24711 19.926 7.37285C19.8747 7.49859 19.7981 7.61251 19.7011 7.70762L10.5843 17.6712C10.4922 17.7732 10.3799 17.855 10.2546 17.9116C10.1293 17.9682 9.99364 17.9983 9.85614 18H9.84617Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/check.0ae4161a51b8541b67d5d7e105538680.svg";
export { ForwardRef as ReactComponent };